import * as THREE from "three"
import AlchemyObject from "./Object"
import { RECIPE } from "./Constants"
import GenericObject from "./GenericObject"
export function combine(_typeA: string, _typeB: string): string | undefined {
    const [typeA, typeB] = [_typeA, _typeB].sort()
    let result = RECIPE[typeA]?.[typeB] ?? RECIPE[typeB]?.[typeA]
    if (!result) {
        if (typeA === "trash" || typeB === "trash") {
            return "trash"
        }
        return undefined
    }
    if (typeof result === "object") {
        const randomValue = Math.random()
        let cumulativeProb = 0
        for (const [type, prob] of Object.entries(result)) {
            cumulativeProb += prob
            if (randomValue <= cumulativeProb) {
                return type
            }
        }
    } else if (typeof result === "string") {
        return result
    }
}

export function instantiate(type: string, position: THREE.Vector3): AlchemyObject | undefined {
    return new GenericObject(type, position)
}